module.exports = __webpack_public_path__ + "img/calender.a14f5da9.svg";